import React, { useState } from "react";
import { getUrl } from "@outplayed/riot-assets";
import PerformanceAnalysisTabs from "./PerformanceAnalysisTabs";
import "moment-duration-format";
import moment from "moment";

const PerformanceAnalysisYourStats = (props) => {
  const [activeTab, setActiveTab] = useState("normal");

  const switchTab = (label) => {
    const newTab = label === "HOWLING ABYSS" ? "howling" : "normal";
    setActiveTab(newTab);
  };
  let { summonerRiftStats, howlingAbyssStats } = props;

  let [statsEntry, howlingStatsEntry] = [null, null];

  if (summonerRiftStats) {
    let towerDuration = moment.duration(summonerRiftStats.fastestTower).format("h:mm:ss");
    statsEntry = [
      { icon: "sword_icon.png", label: "KDA", stat: summonerRiftStats.kda.toFixed(1) },
      { icon: "two_sword_icon.png", label: "AVG DEATHS", stat: summonerRiftStats.avgDeaths.toFixed(1) },
      { icon: "cs_icon.png", label: "AVG CS / MIN", stat: summonerRiftStats.avgCsPerMin.toFixed(1) },
      { icon: "tower_icon.png", label: "AVG TOWERS", stat: summonerRiftStats.avgTowers.toFixed(1) },
      { icon: "ward_icon.png", label: "AVG WARDS / GAME", stat: summonerRiftStats.avgWardsPerGame.toFixed(1) },
      { icon: "tower_icon.png", label: "FASTEST TOWER", stat: towerDuration },
      { icon: "sword_icon.png", label: "AVG KILLS", stat: summonerRiftStats.avgKills.toFixed(1) },
      { icon: "shield_icon.png", label: "AVG ASSISTS", stat: summonerRiftStats.avgAssists.toFixed(1) },
      { icon: "gold_icon.png", label: "GOLD PER MIN", stat: summonerRiftStats.avgGoldPerMin.toFixed(0) },
      { icon: "monster_icon.png", label: "AVG DRAGONS", stat: summonerRiftStats.avgDragons.toFixed(1) },
      { icon: "monster_icon.png", label: "MOST DRAGONS", stat: summonerRiftStats.mostDragons.toFixed(0) },
    ];
  }

  if (howlingAbyssStats) {
    howlingStatsEntry = [
      { icon: "sword_icon.png", label: "KDA", stat: howlingAbyssStats.kda.toFixed(1) },
      { icon: "two_sword_icon.png", label: "AVG DEATHS", stat: howlingAbyssStats.avgDeaths.toFixed(1) },
      { icon: "helmet.png", label: "CHAMPIONS WON WITH", stat: howlingAbyssStats.uniqueChampionWins },
      { icon: "sword_icon.png", label: "AVG KILLS", stat: howlingAbyssStats.avgKills.toFixed(1) },
      { icon: "shield_icon.png", label: "AVG ASSISTS", stat: howlingAbyssStats.avgAssists.toFixed(1) },
      { icon: "gold_icon.png", label: "GOLD PER MIN", stat: howlingAbyssStats.avgGoldPerMin.toFixed(0) },
    ];
  }

  const tabsData = [];
  if (summonerRiftStats) tabsData.push({ label: "SUMMONER'S RIFT", callback: switchTab });
  if (howlingAbyssStats) tabsData.push({ label: "HOWLING ABYSS", callback: switchTab });
  if (!summonerRiftStats && activeTab !== "howling") {
    setActiveTab("howling");
    return <div />;
  }

  const statsToUse = activeTab === "howling" ? howlingStatsEntry : statsEntry;

  if (tabsData.length === 0) {
    return <div></div>;
  }
  return (
    <div className={`your-stats`}>
      <div className="text-container">
        <div className="small-header">OVERVIEW</div>
        <div className="large-header">YOUR STATS</div>
        <div className="basic-text">
          Dive in to your overall stats in each game mode. See how you stack up against the boosted animals you call friends.
        </div>
      </div>

      <PerformanceAnalysisTabs tabsData={tabsData} />

      <div className={`stats-container ${activeTab}`}>
        {statsToUse.map((stat, index) => {
          return (
            <div key={index} className={`your-stats-entry`}>
              <div className="icon-and-label">
                <div className="icon-container">
                  <img className="icon" src={getUrl(`lol/performance_analysis/icons/${stat.icon}`)} />
                </div>
                <div className="label">{stat.label}</div>
              </div>
              <div className="stat">{stat.stat}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PerformanceAnalysisYourStats;
